import { User, PaginatedResponse } from '../types';
import apiService from './api';

export class UserService {
  async getPendingUsers(): Promise<User[]> {
    return apiService.get<User[]>('/api/auth/pending-users');
  }

  async approveUser(userId: string): Promise<void> {
    await apiService.post(`/api/auth/approve-user/${userId}`);
  }

  async rejectUser(userId: string): Promise<void> {
    await apiService.post(`/api/auth/reject-user/${userId}`);
  }

  async getUsersByOrganization(organizationId: string): Promise<User[]> {
    return apiService.get<User[]>(`/api/users/organization/${organizationId}`);
  }

  async createUser(userData: Partial<User>): Promise<User> {
    return apiService.post<User>('/api/users/create', userData);
  }

  async getCurrentUser(): Promise<User> {
    return apiService.get<User>('/api/users/me');
  }

  async deactivateUser(userId: string): Promise<void> {
    await apiService.put(`/api/users/deactivate/${userId}`);
  }

  async activateUser(userId: string): Promise<void> {
    await apiService.put(`/api/users/activate/${userId}`);
  }

  async getAllUsers(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<User>> {
    return apiService.getPaginated<User>('/api/users', page, size, sort, filters);
  }

  async getUserById(userId: string): Promise<User> {
    return apiService.get<User>(`/api/users/${userId}`);
  }

  async updateUser(userId: string, userData: Partial<User>): Promise<User> {
    return apiService.put<User>(`/api/users/${userId}`, userData);
  }
}

export const userService = new UserService();
export default userService;
